import { defineMessages } from 'react-intl';

export const FloorplanStepContent = defineMessages({
  floorplanDoesNotExist: {
    id: 'app.FloorplanStepContent.floorplanDoesNotExist',
    defaultMessage: 'Půdorys k podlaží neexistuje nebo jsi offline.',
  },
});

export const FloorplanStepFooter = defineMessages({
  confirmFloorplan: {
    id: 'app.FloorplanStepFooter.confirmFloorplan',
    defaultMessage: 'Potvrdit půdorys',
  },
  back: {
    id: 'app.common.back',
    defaultMessage: 'Zpět',
  },
});
